import { SURFACE_STYLES } from "./surface-styles";

export const FORM_STYLES = {
  // El contenedor de cada campo
  fieldWrapper: "space-y-1.5",

  // Labels minimalistas y elegantes
  label: "text-xs font-semibold tracking-wide ml-1 transition-colors text-muted-foreground/80 opacity-70",
  labelIcon: "text-xs font-semibold tracking-wide ml-1 transition-colors text-muted-foreground/80 flex items-center gap-2",
  labelError: "text-destructive",

  // El Input base (lo que va dentro del relative)
  input: "h-10 border-border/60 rounded-lg text-base transition-all bg-secondary/5 hover:bg-secondary/10 focus-visible:ring-1 focus-visible:ring-primary",
  inputError: "border-destructive/50 focus-visible:ring-destructive bg-destructive/5",
  inputWithIcon: "pl-10",

  textArea:"w-full min-h-[120px] rounded-lg bg-secondary/5 hover:bg-secondary/10 border border-border/60 p-4 text-xs font-medium focus:outline-none focus:ring-1 focus:ring-primary/20 focus:border-primary transition-all custom-scrollbar resize-y",
  textAreaError: "border-destructive/50 focus-visible:ring-destructive bg-destructive/5",

  // Iconos dentro de inputs
  icon: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 transition-colors duration-200 z-10 text-muted-foreground opacity-40",
  iconRight:
    "absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 transition-colors duration-200 z-10 text-muted-foreground opacity-40",
  iconError: "text-destructive opacity-100",
  iconFocus: "group-focus-within:opacity-100 group-focus-within:text-primary",

  // Mensajes de error
  errorText: "text-xs font-medium text-destructive ml-1 mt-1 animate-in fade-in slide-in-from-top-1",

  // Secciones condicionales (como la de profesionales)
  sectionContainer: "bg-primary/5 p-4 rounded-md border border-primary/10",
  sectionLabel: "text-xs font-bold text-muted-foreground/80 ml-1 mb-3 block",

  /** @deprecated Usar SURFACE_STYLES.tabTriggerUnderline */
  tabItemStyle: SURFACE_STYLES.tabTriggerUnderline,

  // 🎯 BOTONES ESTANDARIZADOS Fysaro
  // Botón principal de formularios (Ancho completo, tracking ancho, sombra)
  submitButton: "w-full h-10 font-semibold text-base shadow-xl shadow-primary/10",
  // Botón de acción estándar (Para tablas, modales, acciones sueltas)
  actionButton: "h-10 px-6 font-semibold text-sm",
  
  iconButton: "h-7 w-7 text-primary hover:text-primary hover:bg-primary/10 rounded-lg",
  iconDesctructiveButton: "h-7 w-7 text-destructive hover:text-destructive hover:bg-destructive/10 rounded-lg",
  
  smallActionButton: "h-6 px-2 text-[9px] uppercase font-black tracking-wider shrink-0 bg-background shadow-sm border border-border/40",
  smallDestructiveActionButton: "h-6 px-2 text-[9px] uppercase font-black tracking-wider shrink-0 bg-destructive shadow-sm border border-border/40 hover:bg-destructive/60 hover:text-foreground",

  // Botón destructivo para acciones de peligro/eliminación
  destructiveButton: "h-10 px-6 font-semibold text-sm bg-destructive text-destructive-foreground hover:bg-destructive/90 shadow-lg shadow-destructive/10",
  // Icono cargador interno
  buttonSpinner: "h-5 w-5 animate-spin",

  buttonPopover: "h-12 border-border/60 rounded-lg text-base hover:text-foreground transition-all bg-secondary/5 hover:bg-secondary/10 focus-visible:ring-1 focus-visible:ring-primary",
  buttonPopoverError: "border-destructive/50 focus-visible:ring-destructive bg-destructive/5",
};
